import { useState } from "react"
import { CREDITOS_WEB_HOST, CREDITOS_WEB_URL } from "@/lib/pwa"

/**
 * Tela de bloqueio mostrada quando o CreditOS é aberto como APP INSTALADO (PWA).
 * O acesso por app foi desativado; o usuário deve usar o navegador. Estilos
 * inline e cores fixas de propósito: a tela renderiza ANTES dos providers/tema,
 * então não depende de CSS de tema (funciona em qualquer estado). Bloqueia a
 * tela inteira — não há como usar o app a partir daqui. (PWA desativado)
 */
const ROXO = "#7027FA"

export function PwaDisabledScreen() {
  const [copied, setCopied] = useState(false)

  async function copyUrl() {
    try {
      await navigator.clipboard.writeText(CREDITOS_WEB_URL)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2500)
    } catch {
      /* clipboard indisponível — o endereço está visível pra digitar */
    }
  }

  return (
    <div
      role="alertdialog"
      aria-label="Acesso pelo app desativado"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483647,
        background: "linear-gradient(160deg, #1b1130 0%, #0e0a18 100%)",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "32px 24px",
        fontFamily:
          "system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        WebkitUserSelect: "none",
        userSelect: "none",
      }}
    >
      <div style={{ maxWidth: 380, width: "100%" }}>
        <div style={{ fontSize: 48, lineHeight: 1, marginBottom: 16 }}>⚠️</div>

        <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 8px" }}>
          O acesso pelo app foi desativado
        </h1>

        <p style={{ fontSize: 15, color: "#c9c2da", margin: "0 0 24px", lineHeight: 1.5 }}>
          Agora o CreditOS é usado direto pelo navegador. Abra o endereço abaixo:
        </p>

        <div
          style={{
            background: "rgba(255,255,255,0.08)",
            border: `1px solid ${ROXO}`,
            borderRadius: 12,
            padding: "14px 16px",
            fontSize: 17,
            fontWeight: 600,
            letterSpacing: 0.2,
            wordBreak: "break-all",
            marginBottom: 12,
            userSelect: "text",
            WebkitUserSelect: "text",
          }}
        >
          {CREDITOS_WEB_HOST}
        </div>

        <button
          type="button"
          onClick={copyUrl}
          style={{
            width: "100%",
            background: copied ? "#1f9d55" : ROXO,
            color: "#fff",
            border: "none",
            borderRadius: 12,
            padding: "14px 16px",
            fontSize: 15,
            fontWeight: 700,
            cursor: "pointer",
            marginBottom: 28,
            transition: "background 0.2s",
          }}
        >
          {copied ? "✓ Endereço copiado" : "Copiar endereço"}
        </button>

        <div
          style={{
            fontSize: 13,
            color: "#9b93ad",
            lineHeight: 1.6,
            textAlign: "left",
            borderTop: "1px solid rgba(255,255,255,0.1)",
            paddingTop: 18,
          }}
        >
          <strong style={{ color: "#c9c2da" }}>Depois, remova este ícone</strong> da
          tela inicial:
          <br />• <strong>Android:</strong> segure o ícone → "Desinstalar" / "Remover".
          <br />• <strong>iPhone:</strong> segure o ícone → "Remover app" → "Excluir
          da Tela de Início".
        </div>
      </div>
    </div>
  )
}
